import { render, staticRenderFns } from "./ListPanel.vue?vue&type=template&id=28431f98&scoped=true"
import script from "./ListPanel.vue?vue&type=script&lang=js"
export * from "./ListPanel.vue?vue&type=script&lang=js"
import style0 from "./ListPanel.vue?vue&type=style&index=0&id=28431f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28431f98",
  null
  
)

export default component.exports